import machine_edit from "./machine_edit_en";
import machine_list from "./machine_list_en";
import income_expenditure from "./income_expenditure_en";
import sale_statistic from "./sale_statistic_en";
const storeModel = {
    machine_edit,
    machine_list,
    income_expenditure,
    sale_statistic
};

export default storeModel;
